
































import { Component, Prop } from 'vue-property-decorator';
import { IUser } from 'admiral-core';
import { HashIcon, ImageIcon, TrendingUpIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import { UserApi } from '@/services/UserApi';

@Component({
  components: { UserStatusBadge, Avatar, HashIcon, TrendingUpIcon, ImageIcon },
})
export default class UserCard extends mixins(FormatMixin) {
  @Prop({ required: true, type: Object })
  u!: IUser;

  isHovered = false;

  async mounted() {
    //
  }
  openFileUpload() {
    (this.$refs.file as HTMLFormElement).click();
  }
  async handleFileUpload() {
    const file = (this.$refs.file as HTMLFormElement).files[0];
    const formData = new FormData();

    formData.append('images', file);
    try {
      await UserApi.setProfilePicture(this.u.id, formData);
      this.$emit('reload');
    } catch (e) {
      this.$toastr.e(
        'Beim Hochladen des Bildes ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
    (this.$refs.file as HTMLFormElement).value = '';
  }
}
